/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Guide_DescriptionInputs */

const en_google_drive_guide_description = /** @type {(inputs: Google_Drive_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the files you want to use in Listening. You can browse and search them here, and add more anytime.`)
};

const es_google_drive_guide_description = /** @type {(inputs: Google_Drive_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige los archivos que quieras usar en Listening. Podrás explorarlos y buscarlos aquí, y añadir más cuando quieras.`)
};

/**
* | output |
* | --- |
* | "Choose the files you want to use in Listening. You can browse and search them here, and add more anytime." |
*
* @param {Google_Drive_Guide_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_guide_description = /** @type {((inputs?: Google_Drive_Guide_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Guide_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_guide_description(inputs)
	return en_google_drive_guide_description(inputs)
});